export default __webpack_public_path__ + "ce1a698.png";